import { render, staticRenderFns } from "./activitiesDetail2022ts.vue?vue&type=template&id=5d7e6185&scoped=true"
import script from "./activitiesDetail2022ts.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2022ts.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2022ts.vue?vue&type=style&index=0&id=5d7e6185&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7e6185",
  null
  
)

export default component.exports